<div class="component-card m-0">
    <div style="display: inline-block;width: 100%;">
        <h1 class="component-title">{{'BUSINESS.PAYMENTS'|translate}} / <span>{{'BUSINESS.PROCESSED'|translate}}</span>
        </h1>
        <i class="pi pi-ellipsis-v spam-menu"></i>
    </div>
    <div class="panel_wrapper">
        <div class="d-flex flex-row justify-content-between pb-4">
            <div class="p-inputgroup div_search_field w-75">
                <button type="button" class="search_btn_icon" (click)="searchPayment(searchPaymentModel)"><i
                        class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" (keydown.enter)="searchPayment(searchPaymentModel)"
                    [(ngModel)]="searchPaymentModel.name" placeholder="{{'SEARCH' | translate}}...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
            </div>
            <p-dropdown class="src_dropdown" [options]="src_drop_opt" [(ngModel)]="selected_drop_opt" optionLabel="name"
                (onChange)="changeSortBy()"></p-dropdown>
            <p-calendar class="search_date_picker" dateFormat="dd/mm/yy"
                placeholder="{{'BUSINESS.DATE' | translate}}..." [showIcon]="true">
            </p-calendar>
            <div class="p-inputgroup div_search_field w-50">
                <button type="button" class="search_btn_icon" (click)="searchPayment(searchPaymentModel)"><i
                        class="pi pi-search"></i></button>
                <input type="text" class="input_text_search_field" (keydown.enter)="searchPayment(searchPaymentModel)"
                    [(ngModel)]="searchPaymentModel.city" placeholder="{{'BUSINESS.LOCATION' | translate}}...">
                <button type="button" class="search_btn_icon" (click)="clearSearch()"><i
                        class="pi pi-times"></i></button>
                <!-- <input type="text" class="input_text_search_field" [(ngModel)]="searchPaymentModel.city" placeholder="{{'BUSINESS.LOCATION' | translate}}...">
                <button type="button" class="search_btn_icon"><i class="pi pi-times"></i></button> -->
            </div>
        </div>
    </div>
</div>

<p-tabView class="payment-tabs">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <label class="w-100 text-centar">PROCESSED <span class="color_mono_txt">({{totalRecords}})</span></label>
        </ng-template>
        <div>
            <ng-container *ngTemplateOutlet="paymentTemplate"></ng-container>
        </div>
    </p-tabPanel>
</p-tabView>


<ng-template #paymentTemplate>
    <p-progressSpinner *ngIf="spinner" class="full_spinner"></p-progressSpinner>
    <div style="padding-right: 4px; height: 430px;overflow-y: auto;overflow-x: hidden;" infiniteScroll
        [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1000" (scrolled)="loadMorePayments()"
        [scrollWindow]="false">
        <div *ngFor="let payment of paymentList" class="component-card">
            <div class="component-list-card">
                <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex flex-row me-3" style="align-items: self-end;">
                        <img class="payment_picture_list"
                            [src]="payment.CompanyImagePath ? payment.CompanyImagePath: imagePath">
                        <div class="company_info ">
                            <h5 class="title">{{payment.companyName}}</h5>
                            <div class="payment_company">
                                <a href="{{payment.companyWebsite}}"> {{payment.companyWebsite}} </a>
                            </div>
                        </div>
                    </div>
                    <div class="div_group_payment">
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'PROCESS DATA' | translate }}</label>
                            <label class="lbl_list">{{ payment.processorName }}</label>
                            <label class="lbl_list_date">{{ payment.paymentDate |date : 'EE, dd MMM yyyy | hh:mm'
                                }}</label>
                        </div>
                        <div class="div_lbl_group">
                            <label class="lbl_color_list">{{ 'INSTALLMENT' | translate }}</label>
                            <label class="lbl_list">{{ payment.productName }}<span> |
                                    ${{payment.amount}}</span></label>
                            <label class="lbl_list_price">${{ payment.amount }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
